import api from "csi/api";
import csi from "csi/main";
import declare from "dojo/_base/declare";
import def from "csi/def";
import FieldConstructor from "csi/def/Field";
import lang from "dojo/_base/lang";
import { sessionStore } from "csi/state/rootStore";
import Widget from "csi/form/Widget";
import xml from "csi/xml";

const RetailProductSKUForm = declare(Widget, {
	AUTOGTIN: "AutoGTIN",

	variantsLabel: "RealizedVariant",

	_getVariantWidgetParams() {
		return api.getAllowNoneOptionForSKUCreation() ? { addItemAll: true } : { defaultAll: true };
	},

	hasProductVariant(product) {
		return this.defView.getField(this.variantsLabel) && product.RetailVariants.length > 0;
	},

	/**
     * @override
     */
	_resolveView() {
		const variantField = this.defView.getField(this.variantsLabel);
		const product = this.defView.getSource()
			.getParent();
		variantField.m_bRequired = true;

		// In the case of creation, the user can select multiple Variants for the creation of multiple SKUs.
		// In the case of editing, the user can only select one option since SKU can only be associated with one Variant.
		if (this.isNew()) {    
			variantField.m_typeControl = def.FIELD_MULTI_SELECT;
    
			if (this.hasProductVariant(product)) {
				variantField.widgetParams = this._getVariantWidgetParams();
			}
		}

		// Add AutoGTIN checkbox for New and Copy form
		if (this.isNew() || this.isCopy()) {
			if (xml.isValidURL(sessionStore.siteCompany.DefaultManufacturerCode)) {
				this.insertField(lang.mixin(new FieldConstructor(), {
					m_label: this.AUTOGTIN,
					m_typeControl: def.FIELD_CHECKBOX,
					bPersist: true,
				}));
			}
		}

		this.inherited(arguments);
	},

	/** retrieve variants that were selected in the form */
	getSelectedVariants(): string[] {
		const selected = [];
		if (!this.isNew()) {
			return selected;
		}
            
		const product = this.defView.getSource()
			.getParent();
		const bHasVariant = this.hasProductVariant(product);

		// get selected variant
		const variants = this.getFormData()
			.getFieldValue(this.variantsLabel, true) || [];
        
		const bHasVariantsSel =  bHasVariant && variants.length > 0;

		if (bHasVariantsSel) {
			variants.forEach((curProductVariant) => {
				selected.push(curProductVariant);
			});
		}

		if (!selected.length) {
			// no variant, just add an empty entry to force creating a new SKU
			selected.push({});
		}

		return selected;
	},

	/** create hash for variant sku */
	getVariantSKUHashKey(variant): string {
		return (variant == null ? csi.EMPTY_URL : variant);
	},

	/** Retrieve a record of current SKUs, so no duplicates are created */
	getExistingSKUs(): Record<string, boolean> {
		const product = this.defView.getSource()
			.getParent();
		const skus = this.cacheView.getNodes(product.RealizedProducts);
		return csi.hashArray(skus,  (node) => {
			return this.getVariantSKUHashKey(node.RealizedVariant);
		});
	},

});

export = RetailProductSKUForm;
